import React from 'react';
import { logEventWithGroups } from '@cultureamp/amplitude';
import chevronRight from '@kaizen/component-library/icons/chevron-right.icon.svg';
import chevronLeft from '@kaizen/component-library/icons/chevron-left.icon.svg';
import { Button } from '@kaizen/button';
import styles from './GetStartedButton.scss';

type Props = {
  buttonLabel: string;
  surveyId: string;
  direction: string;
};

export const GetStartedButton = (props: Props): React$Element<string> => {
  const { buttonLabel, surveyId, direction } = props;

  // don't prevent default, as we need to trigger submit for the rails form
  const handleOnClick = () => {
    logEventWithGroups('Survey Started', {}, { Survey: surveyId });
  };

  const chevronIcon = direction === 'rtl' ? chevronLeft : chevronRight;

  return (
    <div className={styles.wrapper}>
      <Button
        onClick={handleOnClick}
        type="submit"
        label={buttonLabel}
        icon={chevronIcon}
        iconPosition="end"
        data-automation-id="get-started-button"
      />
    </div>
  );
};
